// Whether the dashboard has the public /events page switched on (GET /vl/site-settings).
import { useEffect, useState } from 'react';
import apiClient from '@/lib/api/apiClient';

// One request per page load, shared by every caller.
let cached: Promise<boolean> | null = null;

function load(): Promise<boolean> {
  cached ??= apiClient
    .get('/vl/site-settings')
    .then((r: any) => (r?.data?.eventsPageEnabled ?? r?.eventsPageEnabled) !== false)
    .catch(() => true); // fail open: an API hiccup shouldn't hide the page
  return cached;
}

/** `null` while loading, so callers don't flash a redirect. */
export function useEventsPageEnabled(): boolean | null {
  const [enabled, setEnabled] = useState<boolean | null>(null);
  useEffect(() => {
    let alive = true;
    load().then((v) => alive && setEnabled(v));
    return () => {
      alive = false;
    };
  }, []);
  return enabled;
}
